import * as history from "history";
import { action } from "mobx";
import { Observer } from "mobx-react";
import * as React from "react";
import { useContext, useMemo } from "react";
import { RouterStore, syncHistoryWithStore } from "./MobxReactRouter";
import { UserInfoContext } from "./UserInfoContext";
import { CVPSearchParams, queryStringStore } from "./wsQueryStringStore";

export type IWsRoutePath = string | (string | RegExp)[] | RegExp;

export const wsRouteMatch = (matcher: IWsRoutePath, currentPath) => {
  if (matcher instanceof RegExp) {
    return !!currentPath.toLowerCase().match(matcher);
  }

  if (typeof matcher === "string") {
    return currentPath.toLowerCase().startsWith(matcher.toLowerCase());
  }

  if (Array.isArray(matcher)) {
    return !!matcher.find((path) => {
      if (typeof path === "string") {
        return !!currentPath.toLowerCase().startsWith(path.toLowerCase());
      }

      if (path instanceof RegExp) {
        return !!currentPath.toLowerCase().match(path);
      }

      return false;
    });
  }

  return false;
};

export interface WSRouteProps {
  path: IWsRoutePath;

  render?: any;
  isMatch?: (path: IWsRoutePath) => boolean;
}

export const WSRoute = ({ path, isMatch, render }: WSRouteProps) => {
  const userInfo = useContext(UserInfoContext);

  const observableState = useMemo(
    () => ({
      get isMatch() {
        if (isMatch) return isMatch(path);

        if (
          !window.cvpSandboxType &&
          (queryStringStore.qs[CVPSearchParams.cvpage] || window.cvpEmbedType)
        ) {
          return wsRouteMatch(
            path,
            queryStringStore.qs[CVPSearchParams.cvpage] ||
              userInfo.settings.startPage
          );
        }

        let pathname = routerStore.location.pathname;
        if (!pathname || pathname === "/") {
          pathname = userInfo.settings.startPage;
        }

        return wsRouteMatch(path, pathname);
      },

      get errorMessage() {
        return userInfo.locStore
          .id("08afcb29223c")
          .loc(`En rute med sti ${path} har sluttet å virke`);
      },
    }),
    []
  );

  return (
    <Observer
      render={() =>
        !!observableState.isMatch && (
          <React.Suspense fallback={null}>{render()}</React.Suspense>
        )
      }
    />
  );
};

export const routerStore = new RouterStore();

let isSetup = false;
export const setupRouterStore = action(() => {
  if (isSetup) return;
  isSetup = true;

  /* const id_konsern = document
    .getElementById("hidKonsernId")
    .getAttribute("value"); */
  const browserHistory = history.createBrowserHistory({
    /*basename: `app/${id_konsern}`, */
  });

  return syncHistoryWithStore(browserHistory, routerStore);
});

setupRouterStore();
